<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-work-order-items-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                 [disableCreateRedirection]="true"
                                 [entityFilters]="entityFilters"
                                 (detailSaved)="modal.close($event)"
                                 (detailCancelled)="modal.dismiss()">
    </app-work-order-items-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-work-order-items-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                               [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                               [filters]="filters" [disableRouterLink]="true">
    </app-work-order-items-list>
  </ng-template>
</div>
